import { useState, type FormEvent } from 'react';

/**
 * Modal dialog requiring `closedReason` before a TM admin can close a
 * ticket. The reason is mandatory because the tenant-side UI surfaces it
 * in the closed-thread header so the tenant knows why support closed the
 * ticket.
 */
interface Props {
    onSubmit: (closedReason: string) => void;
    onCancel: () => void;
}

export default function SupportTicketCloseModal({ onSubmit, onCancel }: Props) {
    const [reason, setReason] = useState('');

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        const trimmed = reason.trim();
        if (!trimmed) return;
        onSubmit(trimmed);
    };

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
            }}
            role="dialog"
            aria-modal="true"
        >
            <form onSubmit={handleSubmit} className="card" style={{ minWidth: '20rem', maxWidth: '32rem', background: 'white' }}>
                <h3>Close ticket</h3>
                <p>This will close the ticket. The tenant will see the reason below.</p>
                <div style={{ marginBottom: '1rem' }}>
                    <label htmlFor="closed-reason">Closed reason</label>
                    <input
                        id="closed-reason"
                        type="text"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        required
                        maxLength={500}
                        style={{ width: '100%', padding: '0.5rem', boxSizing: 'border-box' }}
                    />
                </div>
                <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn btn-outline" onClick={onCancel}>
                        Cancel
                    </button>
                    <button type="submit" className="btn">
                        Close
                    </button>
                </div>
            </form>
        </div>
    );
}
